import ajax from './ajax';
import { ajaxErrorCatch } from '@/utils/errorCatch';
import { COMPANY_INFO_URL } from '@/utils/api';

/**
 * 获取企业信息
 * @param body 请求参数
 * @param callback 回调方法
 * @returns null
 */
export default async function fetchCompanyInfo(body: any, callback: Function) {
  const res = await ajaxErrorCatch(ajax.post(`${COMPANY_INFO_URL}?kfuin=${body.kfuin}`, body));
  console.log('🥳 ~ fetchCompanyInfo ~ res', res);
  const { code, data } = res;
  if (code !== 0) return;
  callback && callback(data);
};
